import { Col, Card, Row, Select } from "antd";
import React, { useState } from 'react';
import moment from "moment";
import { AsumsiIcon, Modal, Form, FormItem } from "asumsi-components";
import { IResponsePost } from "@interfaces/iresponse-post";
import Truncate from "react-truncate";

const { Option } = Select;
export const HeroLeft = (props: any) => {
    const { setFieldsValues, fieldsValues, posts, findDataPost, videos, findDataVideo } = props;
    const [fieldsHeroLeftValues, setFieldsHeroLeftValues]: any = useState({ page: null, type: "post" });
    const [showHeroLeftForm, setShowHeroLeftForm] = useState(false);

    const emptyImage = () =>
        <div className={`empty-upload hero-left`}
            onClick={() => {
                setFieldsHeroLeftValues({ page: null, type: 'post' });
                setShowHeroLeftForm(true);
            }}
        >
            <Row justify="space-around" align="middle" style={{ height: "100%" }}>
                <Col style={{ height: "100%" }}>
                    <p className="desc">set featured content</p>
                </Col>
            </Row>
        </div>;

    const onclickRemoveHeroLeft = () => {
        setFieldsValues({ ...fieldsValues, heroLeft: null });
    }

    const defualtImageHeroLeft = (data: any) => <Card
        className="hero-left-card"
        bordered={false}
        cover={<img alt="example" src={data.imageUrl && data.imageUrl} />}
    >
        <div className="badges">
            <div className="badges-post">
                {data.type.toUpperCase()}
            </div>
        </div>
        <div className="display-flex">
            <div className="topic-post">{data.topic?.name ?? 'General'}</div>
            <div className="post-date">{moment(data.publishDateTime).format("DD MMM yyyy HH:mm")}</div>
        </div>
        <div className="post-title">{<Truncate lines={2} ellipsis=" ..." trimWhitespace={true}>{data.title}</Truncate>}</div>
        <div className="card-actions">
            <div className="actions picture">
                <AsumsiIcon icon="trash" onClick={onclickRemoveHeroLeft} />
            </div>
        </div>
    </Card>;

    const optionHeroLeft = () => {
        let option: any = posts ? posts.map((post: IResponsePost) => {
            const objectKey: any = {
                type: "post",
                id: post.id,
                pid: post.pid,
                imageUrl: post.imageUrl,
                title: post.title,
                excerpt: post.excerpt,
                topic: post.topic,
                publishDateTime: post.publishDateTime
            }
            return <Option key={JSON.stringify(objectKey)} value={JSON.stringify(objectKey)}>{post.title}</Option>
        }) : null;

        if (fieldsHeroLeftValues.type === "video") {
            option = videos ? videos.map((video: any) => {
                const objectKey: any = {
                    type: fieldsHeroLeftValues.type,
                    id: video.id,
                    url: video.url,
                    imageUrl: video.thumbnails.medium.url,
                    title: video.title,
                    excerpt: video.description,
                    topic: { name: 'Video' },
                    publishDateTime: video.publishedAt
                }
                return <Option key={JSON.stringify(objectKey)} value={JSON.stringify(objectKey)}>{video.title}</Option>
            }) : null;
        }

        return option;
    }

    const onChangeHeroLeft = (value: any) => {
        if (!value) {
            fieldsHeroLeftValues.type == "video" ? findDataVideo() : findDataPost();
        }
        setFieldsHeroLeftValues({ ...fieldsHeroLeftValues, page: value, errors: [] });
    }

    const onSaveHeroLeft = () => {
        const heroLeft = JSON.parse(fieldsHeroLeftValues.page ?? "");
        setFieldsValues({ ...fieldsValues, heroLeft });
        setShowHeroLeftForm(false);
    }

    const onChangeHeroLeftType = (value: any) => {
        setFieldsHeroLeftValues({ page: null, type: value });
    }

    return <Col span={14} style={{ display: "flex" }}>
        {fieldsValues.heroLeft ? defualtImageHeroLeft(fieldsValues.heroLeft) : emptyImage()}

        <Modal
            key="hero-left-form"
            show={showHeroLeftForm}
            setShow={setShowHeroLeftForm}
            title='Set hero section left'
            okText="Save"
            actionBottom={true}
            onOk={onSaveHeroLeft}
            onCancel={() => setFieldsHeroLeftValues({ page: null, type: 'post' })}
            disableButtonOk={fieldsHeroLeftValues.errors && fieldsHeroLeftValues.errors.length > 0}
        >
            <Card>
                <Form titleBold={true}>
                    <Row gutter={30}>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <FormItem label="Content to display" setFieldsValues={setFieldsHeroLeftValues} fieldsValues={fieldsHeroLeftValues}>
                                <Select style={{ width: "100%" }} defaultValue={fieldsHeroLeftValues.type} value={fieldsHeroLeftValues.type} onChange={onChangeHeroLeftType}>
                                    <Option key="post" value="post">Post</Option>
                                    <Option key="video" value="video">Video</Option>
                                </Select>
                            </FormItem>
                        </Col>
                        <Col lg={{ span: 24 }} md={{ span: 24 }} xs={{ span: 32 }}>
                            <FormItem label="Selected Post" setFieldsValues={setFieldsHeroLeftValues} fieldsValues={fieldsHeroLeftValues} fieldDecorator={{
                                label: "page",
                                rules: [{
                                    message: 'Please select post',
                                    required: true,
                                }
                                ]
                            }}>
                                <Select
                                    style={{ width: "100%" }}
                                    allowClear
                                    onSearch={(value: string) => fieldsHeroLeftValues.type == "video" ? findDataVideo(value) : findDataPost(value)}
                                    showSearch
                                    optionFilterProp="children"
                                    defaultValue={fieldsHeroLeftValues.page}
                                    value={fieldsHeroLeftValues.page}
                                    onChange={onChangeHeroLeft}>
                                    {optionHeroLeft()}
                                </Select>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </Modal>
    </Col>
}

export default HeroLeft;


// WEBPACK FOOTER //
// ./src/pages/homepage-form/libraries/heroLeft.tsx